export const loadAmazonChat = () => {
  const amazonChatWidget = document.getElementById(
    "amazon-connect-chat-widget"
  );

  if (amazonChatWidget) {
    const chatButton = document.querySelector(
      'button[class^="acOpenButton"]'
    ) as HTMLElement;

    chatButton?.click();
  } else {
    const { scriptId, scriptUrl, snippetId } = CONFIG.appConfig.amazonChat;

    if (scriptId && scriptUrl && snippetId) {
      const s = document.createElement("script");
      s.src = scriptUrl;
      s.async = true;
      s.id = scriptId;

      window.amazon_connect = {
        ac: [
          [
            "styles",
            {
              openChat: { color: "#ffffff", backgroundColor: "#004438" },
              closeChat: { color: "#ffffff", backgroundColor: "#004444" }
            }
          ],
          ["snippetId", snippetId],
          ["supportedMessagingContentTypes", ["text/plain", "text/markdown"]],
          [
            "customLaunchBehavior",
            {
              skipIconButtonAndAutoLaunch: true
            }
          ]
        ]
      };

      document.getElementsByTagName("head")[0].appendChild(s);
    }
  }
};
